import * as ActionTypes from '../actionTypes';

// API
import * as HttpApi from '../Api/index';

export const actionTypes = ActionTypes;

//////////////////
///// GET ////////
//////////////////

export const getById = (params) => {
    return (dispatch) => {
        return HttpApi.get('eEVENT_INFO', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

export const getList = (params) => {
    return (dispatch) => {
        return HttpApi.get('eEVENT_LIST', params)
          .then((response) => {
              return Promise.resolve(response.data);
          })
          .catch((err) => {
              return Promise.reject(err);
          });
    };
};

export const getPrizedList = (params) => {
  return (dispatch) => {
    return HttpApi.get('eLogEvent_LIST', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getRequestList = (params) => {
  return (dispatch) => {
    return HttpApi.get('eEVENT_REQUEST_LIST', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const update = (params) => {
    return (dispatch) => {
        return HttpApi.put('eEVENT_UPDATE', params)
          .then((response) => {
              return Promise.resolve(response.data);
          })
          .catch((err) => {
              return Promise.reject(err);
          });
    };
};

export const updateStatus = (params) => {
  return (dispatch) => {
    return HttpApi.put('eEVENT_UPDATE_EEventStatus', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

// 승인요청
export const updateRequest = (params) => {
  return (dispatch) => {
    return HttpApi.put('eEVENT_REQUEST_UPDATE', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

//////////////////
///// POST ///////
//////////////////
export const create = (params) => {
    return (dispatch) => {
        return HttpApi.post('eEVENT_CREATE', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

export const userEventJoin = (params) => {
    return (dispatch) => {
        return HttpApi.post('eUSER_EVENT_JOIN', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }
}

export const userEventSubmit = (params) => {
    return (dispatch) => {
        return HttpApi.post('eUSER_EVENT_SUBMIT', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }
}

export const createRequest = (params) => {
  return (dispatch) => {
    return HttpApi.post('eEVENT_REQUEST_CREATE', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }
}